Array.prototype.findById = function(id){
    let foundIdx = this.findIndex((p) => { return p._id === id });
    if (foundIdx!=-1) {
    	return this[foundIdx];
    }
    else {
    	console.warn("Array.prototype.findById", `${id} not found`, this);
    	return false;
    }
}

